<template>
  <div>
    <v-dialog v-model="calendar_task_report" max-width="1100" persistent>
      <v-card :loading="loading" class="sales-invoice-report">
        <v-card-text class="pt-3">
          <v-row dense>
            <v-col cols="12" style="font-size: 18px;" class="text-center">
              <b>Calendar Task</b>
              <v-divider class="mt-3 mb-3"></v-divider>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="4">
              <v-row dense>
                <v-col cols="3" style="max-width: 22%;">
                  <v-img :src="company_details.logo_path" width="60"></v-img>
                </v-col>
                <v-col class="license-number" style="line-height: 18px;">
                  <div style="font-size: 16px;">{{company_details.name}}</div>
                  <div class="ml-2">{{ company_details.license_number}}</div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4" class="text-center">
              <!-- <div class="ml-2" style="font-size: 18px;"><i><b>Since {{ company_details.company_start_year}}</b></i></div> -->
              <div class="ml-2" style="font-size: 18px;">
                <i>
                  <b></b>
                </i>
              </div>
            </v-col>
            <v-col cols="4" class="text-right">
              Tel :
              <b>{{ company_details.phone_number}}</b>
              <br />
              <a
                :href="company_details.website_link"
                target="_blank"
              >{{ company_details.website_link}}</a>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col
              cols="6"
            >{{company_details.shipping_address_line_1}}, {{company_details.shipping_city_details.city_name}}, {{company_details.shipping_state_details.short_name}} {{company_details.shipping_zip}}</v-col>
            <v-col
              cols="6"
              class="text-right"
            >{{company_details.email+'@'+company_details.domain_details.domain}}</v-col>
          </v-row>
          <v-row dense class="grey lighten-1 ma-1 mt-5">
            <v-col cols="3" class="text-center" style="border-right: solid 1px grey;">
              <span v-if="project_id">{{project_detail ? project_detail.p_name : ''}}</span>
            </v-col>
            <v-col cols="3" class="text-center" style="border-right: solid 1px grey;">
              <span v-if="assign_type">{{assign_type}}</span>
            </v-col>
            <v-col cols="3" class="text-center" style="border-right: solid 1px grey;">
              <span v-if="assign_id">{{assign_name}}</span>
            </v-col>
            <v-col cols="3" class="text-center">
              <span
                v-if="start_time"
              >{{displayDateTimeFormate(start_time)}} To {{displayDateTimeFormate(end_time)}}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-simple-table dense class="custom-table-border mt-5" v-if="project_id!=''">
                <tbody>
                  <tr class="text-center">
                    <td width="20%" class="grey lighten-2">Project</td>
                    <td width="20%">{{ project_detail ? project_detail.p_name : '' }}</td>
                    <td width="20%" class="grey lighten-2">Customer</td>
                    <td
                      width="20%"
                    >{{ project_detail ? project_detail.customer ? project_detail.customer.full_name : '':'' }}</td>
                    <td width="20%" class="grey lighten-2">No. of Change Order</td>
                    <td
                      width="20%"
                    >{{ project_detail ?project_detail.change_order_list > 0 ? project_detail.change_order_list : 0 : 0 }}</td>
                  </tr>
                  <tr class="text-center">
                    <td width="20%" class="grey lighten-2">Order Date</td>
                    <td width="20%">{{ project_detail? project_detail.display_date :'' }}</td>
                    <td width="20%" class="grey lighten-2">Est. Completion Date</td>
                    <td
                      width="20%"
                    >{{ project_detail ? project_detail.estimated_completed_date : '' }}</td>
                    <td width="20%" class="grey lighten-2">R.Completion Date</td>
                    <td width="20%">{{ project_detail ? project_detail.revised_completion_date:'' }}</td>
                  </tr>
                  <tr class="text-center">
                    <td width="20%" class="grey lighten-2">Task Days</td>
                    <td width="20%">{{ project_detail ? '' : ''}}</td>
                    <td width="20%" class="grey lighten-2">Order Days</td>
                    <td width="20%">{{ project_detail ? project_detail.total_order_days :'' }}</td>
                    <td width="20%" class="grey lighten-2">Rescheule Days</td>
                    <td width="20%">{{ project_detail ? getRescheduleDays :'' }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-simple-table dense class="custom-table-border">
                <thead>
                  <tr class="grey lighten-2">
                    <th width="15%" class="text-center">Project</th>
                    <th width="15%" class="text-center">Schedule Date and Time</th>
                    <th width="40%" class="text-center">Task</th>
                    <th width="15%" class="text-center">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in task_list" :key="index">
                    <td class="text-center">{{row.project ? row.project.p_name :''}}</td>
                    <td class="text-center">{{ displayDateTimeFormate(row.task_date, "datetime") }}</td>
                    <td class="text-center">
                      <span>{{row.task.task}}</span>
                      <br />
                      <div
                        v-if="row.task_note"
                        style="text-align:left !important;"
                      >Note: {{row.task_note}}</div>
                    </td>
                    <td class="text-center">{{row.status}}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closePopup()" :disabled="loading">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            @click="generateTaskReport('whole_page',true); is_send_report = false;"
            color="primary"
            class="pr-3 text-capitalize"
          >
            <v-icon left>mdi-printer</v-icon>Print
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
 <script>
import { getCompanyDetails, daysBetweenDates } from "../../plugins/helper";
import axios from "../../plugins/axios";
const moment = require("moment");
export default {
  data() {
    return {
      loading: false,
      company_details: getCompanyDetails(),
      total_page: "",
      active_page: 0,
      preview_pdf_dialog: false
    };
  },
  props: [
    "calendar_task_report",
    "project_id",
    "assign_type",
    "assign_id",
    "task_list",
    "start_time",
    "end_time",
    "assign_name",
    "project_detail"
  ],
  watch: {
    calendar_task_report: function(value) {
      console.log(value);
      this.getTotalPage();
    }
  },
  computed: {
    //   getTotaldays() {
    //   return daysBetweenDates(this.project_detail.display_date, this.project_detail.estimated_completed_date);
    // },
    getRescheduleDays() {
      if (
        this.project_detail.estimated_completed_date &&
        this.project_detail.revised_completion_date
      ) {
        return daysBetweenDates(
          this.project_detail.estimated_completed_date,
          this.project_detail.revised_completion_date
        );
      } else {
        return "";
      }
    }
  },
  components: {},
  methods: {
    displayDateTimeFormate(date, flag) {
      if (flag == "time") {
        return moment(date).format("H:mm:ss");
      } else if (flag == "datetime") {
        return moment(date).format("MM/DD/YYYY H:mm");
      } else {
        return moment(date).format("MM/DD/YYYY");
      }
    },
    closePopup() {
      this.$emit("updateValue");
    },
    getTotalPage() {
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      var formData = new FormData();
      formData.append("flag", "save");
      formData.append("project_id", this.project_id);
      formData.append("type", this.assign_type);
      formData.append("assign_id", this.assign_id);
      formData.append("start_time", this.start_time);
      formData.append("end_time", this.end_time);
      formData.append("assign_name", this.assign_name);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("generate_pdf_flag", "get_total");
      this.loading = true;
      axios
        .post("generate_calendar_task_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          if (response.data.status) {
            this.total_page = response.data.total_page;
          }
          this.loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.loading = false;
        });
    },
    generateTaskReport(is_past_page, direct_print = false) {
      this.loading = true;
      this.active_page++;
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      var formData = new FormData();
      formData.append(
        "generate_pdf_flag",
        is_past_page ? "whole_page" : "single_page"
      );
      formData.append("flag", "save");
      formData.append("project_id", this.project_id);
      formData.append("type", this.assign_type);
      formData.append("assign_id", this.assign_id);
      formData.append("start_time", this.start_time);
      formData.append("end_time", this.end_time);
      formData.append("assign_name", this.assign_name);
      formData.append("user_name", localStorage.getItem("user_id"));
      formData.append("company_id", company_data.company_id);
      formData.append("total_page", this.total_page);
      formData.append("active_page", this.active_page);
      formData.append("direct_print", direct_print);
      axios
        .post("generate_calendar_task_pdf", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          console.log(response);
          if (is_past_page) {
            if (response.data.status) {
              if (direct_print) {
                var File_url = response.data.file_url;
                window.open(File_url, "Download");
              } else {
                this.setAlert({
                  show: true,
                  variant: "primary",
                  message: response.data.message,
                  dismissCountDown: 0
                });
              }
              this.loading = false;
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },

  created: function() {},
  mounted: function() {}
};
</script>
 
 <style>
.sales-invoice-report p {
  margin-bottom: 0px;
}
</style>
 